"use strict";

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (angular) {
  "use strict";

  angular.module("fleetviewApp").component("reportsData", {
    template: require("./reports.component.html"),
    controller: reportsDataController
  });

  reportsDataController.$inject = ["$scope", "$location", "LayoutService", "complianceService", "$stateParams", "$state", "$translate", "papaparse", "filesaver", "moment", "$window", "cacheService", "timeService", "UserProvider"];

  function reportsDataController($scope, $location, LayoutService, complianceService, $stateParams, $state, $translate, papaparse, filesaver, moment, $window, cacheService, timeService, UserProvider) {
    var vm = this;
    vm.settings = $stateParams.settings;

    //Refreshed page in reports data state: fetch the search settings from cache
    if ((!vm.settings || _.isEmpty(vm.settings)) && $state.is("reports.groups.group.data")) {
      vm.settings = cacheService.getSearchSettings();
      if (!vm.settings) vm.settings = {};
    }

    vm.$onInit = init;
    vm.nextCompliancePage = nextCompliancePage;
    vm.previousCompliancePage = previousCompliancePage;
    vm.downloadReportCSV = downloadReportCSV;
    vm.printReport = printReport;
    vm.getDateRange = getDateRange;
    vm.hideQuestionable = vm.settings ? vm.settings.noQuestionableRoutes : "true"; //user's selection
    vm.getDisplayAddress = getDisplayAddress;
    vm.getDisplayTimeDiff = getDisplayTimeDiff;
    vm.onFilterChanged = onFilterChanged;

    function init() {
      vm.selectedRouteId = 0;
      //route color properties
      vm.routeColors = ["#00ff06", "#027ffb", "#a55fff", "#2448ff", "#fc5800", "#02d4cf", "#ce4871", "#fe9300"];
      vm.currentColor = 0;
      //pagination properties
      vm.firstItemNum = 1;
      vm.lastItemNum = 10;
      vm.totalRoutesNum = 10000;
      vm.currentPageNum = 1;
      //vm.oorCost = 1;
      vm.totalPagesNum = 1;
      vm.routeList = [];
      vm.isLoading = false;

      vm.filterby = cacheService.getCache().complianceReportFilters;
      if (cacheService.getCache().gridSortType) {
        vm.sortType = cacheService.getCache().gridSortType;
        vm.sortReverse = cacheService.getCache().gridSortReverse;
      }

      //Refreshed page in reports data state: re-view the group data
      if ($state.is("reports.groups.group.data")) {
        viewSelectedVehicles();
      }

      $scope.$watch(function () {
        return vm.settings;
      }, function () {
        var pageNumber = $location.search().pageNumber;
        if (_isNumber(pageNumber)) {
          pageNumber = parseInt(pageNumber);

          vm.currentPageNum = pageNumber;
        } else {
          vm.currentPageNum = 1;
        }
        viewSelectedVehicles(); //comment this
      });
    }

    function previousCompliancePage() {
      vm.currentPageNum--;
      vm.routeList = [];
      viewSelectedVehicles();
    }

    function nextCompliancePage() {
      vm.currentPageNum++;
      vm.routeList = [];
      viewSelectedVehicles();
    }

    function leftPanelWidth() {
      return LayoutService.getLeftPanelWidth();
    }

    // todo: put into common file
    function _isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function downloadReportCSV() {
      var csvArray = getCSVArray();
      var exportString = papaparse.unparse(csvArray, {
        delimiter: ",",
        header: false
      });

      try {
        var isFileSaverSupported = !!new Blob();
      } catch (e) {
        console.error("File download API not supported in this browser");
        return;
      }
      var file = new Blob([exportString], {
        type: "text/plain;charset=utf-8"
      });
      filesaver.saveAs(file, "compliance-reports_" + moment().format("YYYYMMDD") + ".csv");
    }

    function printReport() {

      //Move the print section to body because a scrollable div that is to be printed must be on top-level body to be printed on multiple pages
      var element = $("#section-to-print").detach();
      $("body").append(element);

      //Make the print section visible
      $("#section-to-print").show();

      //Set the print date on the report
      $("#print-date").html(getDateRange());

      //Generate the print report table in the div
      var csvArray = getCSVArray();
      var tableStr = "";
      for (var i = 0; i < csvArray.length; i++) {
        var tdEl = "td";
        if (i === 0) {
          tdEl = "th";
        }
        tableStr += "<tr>";
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(csvArray[i]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var val = _step.value;

            tableStr += "<" + tdEl + ">";
            tableStr += val;
            tableStr += "</" + tdEl + ">";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        tableStr += "</tr>";
      }
      $("#print-table").html(tableStr);

      //Actually call the browser print function
      $window.print();

      //Once that is done, re-hide the print div
      $("#section-to-print").hide();
    }

    function getDateRange() {
      if (!vm.settings || !vm.settings.startDate || !vm.settings.endDate) {
        return "";
      }
      return moment(vm.settings.startDate).format("MM/DD/YYYY") + " - " + moment(vm.settings.endDate).format("MM/DD/YYYY");
    }

    function getCSVArray() {
      var csvArray = [];
      var headerRow = [];
      headerRow.push($translate.instant("views.reports.TripID"));
      headerRow.push($translate.instant("views.reports.DriverLabel"));
      headerRow.push($translate.instant("views.reports.DriverID"));
      headerRow.push($translate.instant("views.reports.VehicleLabel"));
      headerRow.push($translate.instant("views.reports.VehicleID"));
      headerRow.push($translate.instant("views.reports.routeSource"));
      headerRow.push($translate.instant("views.compliance.routingProfile"));
      headerRow.push($translate.instant("views.reports.cancelled"));
      headerRow.push($translate.instant("views.reports.plannedDistance"));
      headerRow.push($translate.instant("views.reports.actualDistance"));
      headerRow.push($translate.instant("views.reports.distanceDifference"));
      headerRow.push($translate.instant("views.reports.plannedTime"));
      headerRow.push($translate.instant("views.reports.actualTime"));
      headerRow.push($translate.instant("views.reports.timeDifference"));
      headerRow.push($translate.instant("views.compliance.isOor"));
      headerRow.push($translate.instant("views.reports.oorDistance"));
      headerRow.push($translate.instant("views.reports.originAddress"));
      headerRow.push($translate.instant("views.reports.startTime"));
      headerRow.push($translate.instant("views.reports.destinationAddress"));
      headerRow.push($translate.instant("views.reports.destinationTime"));
      headerRow.push($translate.instant("views.reports.stops"));
      headerRow.push($translate.instant("views.reports.unpredictable"));
      csvArray.push(headerRow);

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(vm.routeList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var route = _step2.value;

          var row = [];
          row.push(route.tripId);
          row.push(route.driverName);
          row.push(route.driverId);
          row.push(route.vehicleName);
          row.push(route.vehicleId);
          row.push(route.routeSource);
          row.push(route.routeProfile);
          row.push(route.isCancelled);
          row.push(route.distancePlanned);
          row.push(route.distanceActual > 0 ? route.distanceActual : "");
          row.push(route.distanceActual > 0 ? route.distanceDifference : "");
          row.push(route.distanceActual > 0 ? route.timePlanned : "");
          row.push(route.distanceActual > 0 ? route.timeActual : "");
          row.push(getDisplayTimeDiff(route));
          row.push(route.isOor);
          row.push(route.oorDistance > 0 ? route.oorDistance : 0);
          row.push(getDisplayAddress(route.originAddress));
          row.push(route.originTime);
          row.push(getDisplayAddress(route.destinationAddress));
          row.push(route.destinationTime);
          row.push(route.stopCount);
          row.push(route.questionable);

          //For each row: if it is null or undefined, replace it with the empty string, to prevent null or undefined from showing in CSV/print report
          for (var i = 0; i < row.length; i++) {
            if (row[i] === null || row[i] === undefined) {
              row[i] = "";
            }
          }

          csvArray.push(row);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return csvArray;
    }

    function getDisplayTimeDiff(route) {
      if (route.distanceActual <= 0 || !route.timePlanned || !route.timeActual) {
        return "--";
      }
      var timeDiff = route.timeDifference;
      if (timeDiff.length > 0 && timeDiff[0] !== "-" && timeDiff !== "0:00") {
        timeDiff = "+" + timeDiff;
      }
      return timeDiff;
    }

    function getDisplayAddress(address) {
      if (!address) {
        return "";
      }
      var displayAddress = address;
      displayAddress = displayAddress.replace(/,/g, ", ");
      displayAddress = displayAddress.replace(/,  /g, ", ");
      return displayAddress;
    }

    function onFilterChanged() {
      cacheService.getCache().gridSortType = vm.sortType;
      cacheService.getCache().gridSortReverse = vm.sortReverse;
      cacheService.saveCache();
    }

    /**
     * Uses the current set filter parameters to query the compliance service to return a list of all compliance routes.
     *
     * @returns a Promise object representing the completion of querying the service and setting the returned routes on the model.
     */
    function viewSelectedVehicles() {

      if (vm.isLoading) {
        return;
      }
      vm.isLoading = true;

      if (vm.settings == null) {
        vm.routeList = [];
        return;
      }

      var user = JSON.parse(window.sessionStorage["userAuthInfo"]);

      var accountId = user.accountId;
      var currentUser = UserProvider.getUser();
      if (currentUser.supportAccount) {
        accountId = currentUser.supportAccount.accountId;
      }

      var p = {
        "accountId": accountId,
        "pageNumber": vm.currentPageNum,
        //"pageSize":  vm.totalRoutesNum,
        "noCoords": false,
        "oorCost": 0.0,
        "sort": "VehicleName",
        "order": "asc",
        "isOor": false,
        "hideCoords": true
      };

      var allParams = angular.merge({}, p, vm.settings);

      //console.log("querying for compliance data with ", allParams);

      return complianceService.getComplianceData(allParams).then(function (resp) {
        if (resp.results) {
          vm.totalRoutesNum = resp.results.totalRoutes;
          vm.totalPagesNum = resp.results.totalPages;

          vm.firstItemNum = 1;
          vm.lastItemNum = vm.totalRoutesNum;

          vm.routeList = resp.results.routes.map(function (route) {
            return _mapRoute(route);
          });
        }
      }, function (err) {
        // todo: show user some type of notification of the error
        console.log("error!", err);
      }).finally(function () {
        vm.isLoading = false;
      });
    }

    /**
     * Converts a route returned from the compliance data to a format usable for this component.
     *
     * @param {any} route
     * @returns
     */
    //function(){}
    //  TODO: clean this up
    function _mapRoute(route) {
      var r = {};
      var stops = {};
      r.tripId = route.tripId;
      r.routeColor = vm.routeColors[vm.currentColor];
      r.routeColorClass = "routeColor" + vm.currentColor;

      vm.currentColor++;
      if (vm.currentColor >= 8) {
        vm.currentColor = 0;
      }

      r.driverName = route.driverName;
      r.vehicleName = route.vehicleName;
      r.driverId = route.prescribedRoute.driverId;
      r.vehicleId = route.deviceId;
      r.showStops = false;
      r.isCancelled = route.effectedRoute.canceled === true ? "Yes" : "No";
      r.cancelledFilter = !route.effectedRoute.canceled;
      r.questionable = route.effectedRoute.questionable === true ? "Yes" : "No";
      r.isCompleted = route.effectedRoute.distance > 0 ? true : false;
      r.routeSource = route.prescribedRoute.routeSource.toUpperCase();
      if (r.routeSource !== "MANUAL" && r.routeSource !== "INTEGRATION" && r.routeSource !== "ROUTESYNC") {
        if (r.routeSource === "DISPATCH") {
          r.routeSource = "INTEGRATION";
        } else {
          r.routeSourceOther = "unknown";
        }
      }
      r.routeProfile = route.prescribedRoute.routingProfileName || "--";

      if (route.prescribedRoute.tripStops.length > 0) {
        r.originStopName = route.prescribedRoute.tripStops[0].stopName !== "GPS Location" ? route.prescribedRoute.tripStops[0].stopName : "";
        r.originStreet = route.prescribedRoute.tripStops[0].street;
        r.originStreet = r.originStreet ? r.originStreet + ", " : "";
        r.originCity = route.prescribedRoute.tripStops[0].city;
        r.originState = route.prescribedRoute.tripStops[0].state;
        r.originZip = route.prescribedRoute.tripStops[0].zip;
        r.originAddress = r.originStopName + " " + r.originStreet + r.originCity + "," + r.originState + "," + r.originZip;
        r.originOffset = route.effectedRoute.routeStartUtcOffset;
        r.originTime = timeService.getFormattedTime2(route.effectedRoute.routeStart, route.effectedRoute.routeStartUtcOffset);
        if (route.effectedRoute.routeStartUtcOffset) {
          r.originTimeStamp = route.effectedRoute.routeStart;
        }
        r.originLonLat = new ALKMaps.LonLat(route.prescribedRoute.tripStops[0].longitude, route.prescribedRoute.tripStops[0].latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
        r.destinationStopName = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].stopName !== "GPS Location" ? route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].stopName : "";
        r.destinationStreet = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].street;
        r.destinationStreet = r.destinationStreet ? r.destinationStreet + ", " : "";
        r.destinationCity = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].city;
        r.destinationState = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].state;
        r.destinationZip = route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].zip;
        r.destinationAddress = r.destinationStopName + " " + r.destinationStreet + " " + r.destinationCity + "," + r.destinationState + "," + r.destinationZip;
        r.destinationOffset = route.effectedRoute.routeEndUtcOffset;
        r.destinationTime = timeService.getFormattedTime2(route.effectedRoute.routeEnd, route.effectedRoute.routeEndUtcOffset);
        if (route.effectedRoute.routeEndUtcOffset) {
          r.destinationTimeStamp = route.effectedRoute.routeEnd;
        }
        r.destinationLonLat = new ALKMaps.LonLat(route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].longitude, route.prescribedRoute.tripStops[route.prescribedRoute.tripStops.length - 1].latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
        //route.prescribedRoute.tripStops[1] = stop1; route.prescribedRoute.tripStops[2] = stop2; route.prescribedRoute.tripStops[3] = stop3; length of stops not known
        if (route.prescribedRoute.tripStops.length > 2) {
          for (var i = 1; i < route.prescribedRoute.tripStops.length - 1; i++) {
            stops[i] = [];
            stops[i].stopNumber = i;
            stops[i].stopName = route.prescribedRoute.tripStops[i].stopName !== "GPS Location" ? route.prescribedRoute.tripStops[i].stopName : "";
            stops[i].stopStreet = route.prescribedRoute.tripStops[i].street;
            stops[i].stopStreet = stops[i].stopStreet ? stops[i].stopStreet + ", " : "";
            stops[i].stopCity = route.prescribedRoute.tripStops[i].city;
            stops[i].stopState = route.prescribedRoute.tripStops[i].state;
            stops[i].stopZip = route.prescribedRoute.tripStops[i].zip;
            stops[i].stoplonLat = new ALKMaps.LonLat(route.prescribedRoute.tripStops[i].longitude, route.prescribedRoute.tripStops[i].latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
          }
          r.stops = stops;
        }
        r.stopCount = route.prescribedRoute.tripStops.length - 2;
      } else {
        console.log("no trips stops! todo: log error. ", route);
      }

      r.distancePlanned = route.prescribedRoute.distance;
      r.distanceActual = route.effectedRoute.distance;
      r.distanceDifference = route.distanceDelta;

      r.timePlanned = moment.duration(route.prescribedRoute.time / 1000, "hours").format("h:mm", {
        trim: false
      });
      r.timeActual = moment.duration(route.effectedRoute.time / 1000, "hours").format("h:mm", {
        trim: false
      });
      r.timeDifference = moment.duration(route.timeDelta / 1000, "hours").format("h:mm", {
        trim: false
      });
      r.isDelayed = r.timePlanned < r.timeActual ? true : false;
      r.oorDistance = route.oorDistance;
      r.isOor = route.outOfRouteEvents.events.length > 0 ? route.outOfRouteEvents.events.length : "None";
      r.noEvents = r.isOor !== "None" ? true : false;
      r.stopList = _.map(route.prescribedRoute.tripStops, function (stop) {
        return new ALKMaps.LonLat(stop.longitude, stop.latitude).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
      });

      r.plannedRoutePoints = [];
      if (route.prescribedRoute.coords.length > 0) {
        r.plannedRoutePoints = _.map(route.prescribedRoute.coords, function (p) {
          return new ALKMaps.Geometry.Point(p[0], p[1]).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
        });
      }

      r.actualRoutePoints = [];
      if (route.effectedRoute.coords.length > 0) {
        r.actualRoutePoints = _.map(route.effectedRoute.coords, function (p) {
          return new ALKMaps.Geometry.Point(p[0], p[1]).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
        });
      }

      r.outOfRouteEvents = [];
      if (route.outOfRouteEvents.events.length > 0) {
        r.outOfRouteEvents = _.map(route.outOfRouteEvents.events, function (e) {
          return {
            type: e.type,
            lonlat: new ALKMaps.LonLat(e.lon, e.lat).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913")),
            point: new ALKMaps.Geometry.Point(e.lon, e.lat).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913")),
            distanceOOR: e.distanceOOR,
            timeStamp: e.timeStamp,
            timeStampUtcOffset: e.timeStampUtcOffset
          };
        });
      }
      return r;
    }
  }
})(window.angular);


// WEBPACK FOOTER //
// ./app/reports/reports.controller.js